module.exports = __webpack_public_path__ + "img/DSC_1116.f5e4df8e.jpg";